import { Fragment, ReactElement } from 'react';
import CancellationDeathNotificationCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-death/detail';

const CancellationDeathNotificationCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <CancellationDeathNotificationCivilStatusShared />
    </Fragment>
  );
};

CancellationDeathNotificationCivilStatusPage.displayName =
  'Cancellation Death Notification Page component';

export default CancellationDeathNotificationCivilStatusPage;
